import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=525f8a49&"
import script from "./Lab.vue?vue&type=script&lang=js&"
export * from "./Lab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports